import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import connectionReducer from '../features/connection/connectionSlice';
import gameReducer from '../features/game/gameSlice';
import initReducer from '../features/init/initSlice';
import roomReducer from '../features/room/roomSlice';
import roomsReducer from '../features/rooms/roomsSlice';
import settingsReducer from '../features/settings/settingsSlice';
import userReducer from '../features/user/userSlice';
import viewReducer from '../features/view/viewSlice';
import websocketReducer from '../features/websocket/websocketSlice';
import websocketController from '../features/websocket/websocketController';
import { default as reduxWebsocket } from '@giantmachines/redux-websocket';
import { createLogger } from 'redux-logger'
import { Builder } from 'xml2js';
import { getSession, getState } from '../util/storage';
import { isAndroidApp } from '../util/app';

const getStore = (connectionArgs) => {
  const reduxWebsocketMiddleware = reduxWebsocket({
    serializer: (payload) => {
      var builder = new Builder({headless: true});
      var xml = builder.buildObject(payload);
      const s = xml+'\0', arr = new Uint8Array(s.length);
      for (let i = 0; i < s.length; i++) { const c = s.charCodeAt(i); arr[i] = c > 255 ? 63 : c; }
      return arr;
    },
    onOpen: (socket) => {
      socket.binaryType = 'arraybuffer';
    }
  });

  const optionalMiddleware = [];
  if (connectionArgs.log > 0) {
    const predicate = connectionArgs.log === 1 ? (_state, action) => action.type !== 'action/auto/tick' && action.type !== 'game/tick' : () => true;
    optionalMiddleware.push(createLogger({predicate}));
  }

  if (isAndroidApp) {
    const state = getState();
    if (state !== null && state.tab === 'room') {
      connectionArgs.roomID = state.id;
    }
  }

  const preloadedState = {
    init: {
      connectionArgs,
    }
  };

  if (connectionArgs.userID !== undefined && connectionArgs.authkey !== undefined) {
    preloadedState.user = {
      id: connectionArgs.userID,
      authkey: connectionArgs.authkey,
    }
  } else {
    const session = getSession();
    if (session !== null) {
      preloadedState.user = {
        id: session.userID,
        authkey: session.authkey,
      };
    }
  }

  const store = configureStore({
    reducer: {
      connection: connectionReducer,
      game: gameReducer,
      init: initReducer,
      room: roomReducer,
      rooms: roomsReducer,
      settings: settingsReducer,
      user: userReducer,
      view: viewReducer,
      websocket: websocketReducer,
    },
    middleware: [...optionalMiddleware, reduxWebsocketMiddleware, websocketController(connectionArgs), ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['meta.arg', 'meta.timestamp', 'payload'], // TODO https://github.com/giantmachines/redux-websocket/pull/128#issuecomment-689036928
      },
    })],
    preloadedState
  });

  store.dispatch({type: 'api/request', payload: { func: 'get_rooms'} });

  return store;
}

export default getStore;
